import React from 'react';
import { DateTimeText } from './DateTimeText';
import { formatUserName } from '../utils/format.utils';
import type { AuditUser } from '../types/pre-registration.types';

interface AuditInfoProps {
  createdAt: string;
  updatedAt: string;
  // Rows embedded in a list come without the users
  createdByUser?: AuditUser | null;
  updatedByUser?: AuditUser | null;
  // The caller already shows the same date (e.g. the row's status date)
  hideUpdatedAt?: boolean;
}

export const AuditInfo: React.FC<AuditInfoProps> = ({
  createdAt,
  updatedAt,
  createdByUser,
  updatedByUser,
  hideUpdatedAt = false,
}) => (
  <div className="space-y-0.5 text-xs text-gray-500">
    <p>
      Creado el <DateTimeText value={createdAt} />
      {createdByUser !== undefined && ` por ${formatUserName(createdByUser)}`}
    </p>
    {!hideUpdatedAt && (
      <p>
        Última modificación el <DateTimeText value={updatedAt} />
        {updatedByUser !== undefined && ` por ${formatUserName(updatedByUser)}`}
      </p>
    )}
  </div>
);
